import React from "react";
import PropTypes from "prop-types";
import { FaAngleLeft, FaAngleRight } from "../shared/icons";

const VerticalArrow = props => {
  const { direction, onClick } = props;

  return (
    <div className="verticalSlider">
      <div
        className={
          direction === "prev" ? "arrow leftArrow" : "arrow rightArrow"
        }
        onClick={onClick}
      >
        {direction === "prev" ? <FaAngleLeft /> : <FaAngleRight />}
      </div>
    </div>
  );
};

VerticalArrow.propTypes = {
  direction: PropTypes.oneOf(["prev", "next"]),
  onClick: PropTypes.func
};

export default VerticalArrow;
